export const AlcoholGramsPerDrink = [
  {
    id: 'wine',
    grams: 15.4,
    label: 'Glass of Wine (175 ml / 11% ABV)',
  },
  {
    id: 'beerPint',
    grams: 18.4,
    label: 'Pint of Beer (568 ml / 4% ABV)',
  },
  {
    id: 'beerBottle',
    grams: 13.2,
    label: 'Bottle of Beer (330 ml / 5% ABV)',
  },
  {
    id: 'alcoholicPop',
    grams: 8.8,
    label: 'Alcoholic Pop Drink (275 ml / 4% ABV)',
  },
  {
    id: 'spiritShot',
    grams: 8.0,
    label: 'Shot of Spirits (25 ml / 40% ABV)',
  },
]
